//
//
//
//
//
//
//

export default {
  setup() {
    const items = ['Programming', 'Design', 'Vue', 'Vuetify']

    return { items }
  },
}
